export default __webpack_public_path__ + "static/media/no-image-available.467ba2df.jpg";